export type ExtendedWindow = Window & typeof globalThis & {
	plausible: any
}
const win = <ExtendedWindow>window;
win.plausible = win.plausible || function() { (win.plausible.q = win.plausible.q || []).push(arguments) };



class A4iLocalStorageInput extends HTMLElement {
	#input: HTMLInputElement;
	constructor() {
		super();

		const $input = this.querySelector<HTMLInputElement>(this.dataset.sel ?? 'input,select,textarea');
		if (!$input?.name) throw new Error('Input with name is required');
		this.#input = $input;

		if (this.#input.type === 'radio') {
			console.warn('/!\\ The radio inputs are not supported /!\\');
		}

		if (this.#input.type === 'checkbox') {
			this.#input.checked = !!this.localValue;
		} else if (this.localValue !== null) {
			this.#input.value = this.localValue;
		}

		this.#input.addEventListener('input', this.#onChange.bind(this));
		this.#input.addEventListener('change', this.#onChange.bind(this));
	}

	get name() {
		return this.#input.name;
	}

	get localValue() {
		return localStorage.getItem(this.name);
	}
	set localValue(value: string|null) {
		if (this.#input.type === 'checkbox') {
			value = this.#input.checked ? value : null;
		}
		if (value) {
			localStorage.setItem(this.name, value);
		} else {
			localStorage.removeItem(this.name);
		}
	}

	#onChange() {
		this.localValue = this.#input.value;
	}
}
customElements.define('a4i-localstorage-input', A4iLocalStorageInput);



(async function () {
	let userId:string|null|undefined = undefined;

	const setUserId = (userId:string|null|undefined) => {
		if (userId === undefined) return;
		sessionStorage.setItem('userId', btoa(JSON.stringify([Date.now(), userId])));
	}

	try {
		const sessionStorageId = 'userId',
			rawUser = document.scripts.namedItem('head-script')?.dataset.user;
		if (rawUser) {
			const user = JSON.parse(rawUser);
			if (user === null) {
				userId = null;
			} else if (typeof user === 'string') {
				userId = user;
			}
			setUserId(userId);
		} else {
			const sessionStorageUser = sessionStorage.getItem(sessionStorageId);
			if (sessionStorageUser) {
				const [timestamp, user] = JSON.parse(atob(sessionStorageUser));
				if ((Date.now() - timestamp) > 5 * 60_000 || Date.now() < timestamp) {
					self.sessionStorage.removeItem(sessionStorageId);
				} else {
					userId = user;
				}
			}
		}
	} catch (e) {
		console.error(e);
	}

	if (userId === undefined) {
		try {
			const userData = await (await fetch('/user/me')).json();
			if (userData && typeof userData === 'object' && userData.userId !== undefined) {
				userId = userData.userId;
				setUserId(userId);
			}
		} catch (e) {
			console.error(e);
		}
	}

	document.dispatchEvent(new CustomEvent('a4i-user', {detail: { userId: userId }}));
})().catch(console.error);
